// src/components/VisionSection.js
import React from 'react';
import './VisionSection.css';

function VisionSection() {
  return (
    <section className="vision">
      <h2>🌟 Our Vision</h2>
      <p>
        We are building a platform to empower students and farmers through GenAI.
        In an era of low trust, we stand for transparency, purpose, and nation-building.
        This program is not just about internships — it's about impact.
      </p>
    </section>
  );
}

export default VisionSection;
